import axios from "axios";

const API = process.env.REACT_APP_API_URL;
const API_GO = process.env.REACT_APP_API_GO;

export const getDashboardFilters = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/filters`, {
		params,
	});
	return data;
};

export const getDashboardSales = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/sales`, {
		params,
	});
	return data;
};

export const getDashboardPrices = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/prices`, {
		params,
	});
	return data;
};

export const getDashboardValorization = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/valorization`, {
		params,
	});
	return data;
};

export const getDashboardValorizationGraph = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/valorization/graph`, {
		params,
	});
	return data;
};

export const getDashboardExpiration = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/expiration`, {
		params,
	});
	return data;
};

export const getDashboardOut = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/out`, {
		params,
	});
	return data;
};

export const getDashboardLast = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/last`, {
		params,
	});
	return data;
};

export const getDashboardSalesDealer = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/sales_dealer`, {
		params,
	});
	return data;
};

export const getDashboardUsedBC = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/used_business_center`, {
		params,
	});
	return data;
};

export const getDashboardNote = async () => {
	const { data } = await axios.get(`${API}/client/dashboard/notes`);
	return data;
};

export const saveNote = async (params) => {
	const { data } = await axios.post(`${API}/client/dashboard/save_notes`, params);
	return data;
};

export const changeOption = async (params) => {
	const { data } = await axios.post(`${API}/client/dashboard/change_option`, params);
	return data;
};

export const getRotate = async (params) => {
	const { data } = await axios.get(`${API}/client/dashboard/rotate`, {
		params,
	});
	return data;
};

export const getOAs = async (params) => {
	const formattedParams = {};

	for (const [key, value] of Object.entries(params)) {
		if (Array.isArray(value)) {
			formattedParams[key] = value.join(",");
		} else if (value !== undefined && value !== null) {
			formattedParams[key] = value;
		}
	}

	const { data } = await axios.get(`${API_GO}/app/dashboard/oa`, {
		params: formattedParams,
	});
	return data;
};
